import { buildQueryKey } from '@webapp/core/utils/react-query/buildQueryKey'
import { type RepoFilterParams } from '@webapp/infrastructure/interfaces/repositories/RepoFilterParams'
import { primaryCategoryRepository } from '@webapp/platform/organization-management'

const base = ['report-access-secondary-category']

export const reportAccessSecondaryCategoryQueryConfig = {
  list: (primaryCategoryId: number, params?: RepoFilterParams) => ({
    queryKey: buildQueryKey([...base, 'list', primaryCategoryId, params]),
    queryFn: () =>
      primaryCategoryRepository.listSecondaryCategoryConfigs(
        primaryCategoryId,
        params ?? {}
      ),
  }),
}
